import { gql } from "@apollo/client";
import { useDeleteDashboardScheduleMutation } from "lib/types/graphql";
import { getRefetchDashboardScheduleOptions } from "./useDashboardSchedule";

import type { SessionWithUser } from "lib/users/types";

import * as Sentry from "@sentry/react";

export function useDeleteDashboardSchedule() {
  const [
    callDeleteDashboardScheduleMutation,
    deleteDashboardScheduleResult,
  ] = useDeleteDashboardScheduleMutation();

  function deleteDashboardSchedule(
    session: SessionWithUser,
    args: { dashboardId: number; scheduleId: string }
  ): Promise<void> {
    if (deleteDashboardScheduleResult.loading) {
      return new Promise(() => {});
    }

    return new Promise((resolve) => {
      callDeleteDashboardScheduleMutation({
        context: { session },
        variables: { cron_job_id: args.scheduleId },
        refetchQueries: [
          getRefetchDashboardScheduleOptions(session, args.dashboardId),
        ],
      }).then(
        () => {
          resolve();
        },
        (error) => {
          error.message =
            "Failed to delete dashboard schedule: " + error.message;
          Sentry.captureException(error);
        }
      );
    });
  }

  return [deleteDashboardSchedule, deleteDashboardScheduleResult] as const;
}

gql`
  mutation DeleteDashboardSchedule($cron_job_id: String!) {
    delete_dashboard_schedule(cron_job_id: $cron_job_id) {
      cron_job_id
    }
  }
`;
